module.exports = __webpack_public_path__ + "7d088296/img/arrow-left-icon.785c715c.svg";